// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shares-list li[data-v-7ba76c5c]{display:flex;justify-content:space-between;line-height:44px}`, "",{"version":3,"sources":["webpack://./src/shared/components/ncContextResource/ResourceSharePermissions.vue"],"names":[],"mappings":"AACA,iCACC,YAAA,CACA,6BAAA,CACA,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
